import { Link } from "react-router-dom";
import { ShieldAlert, ExternalLink } from "lucide-react";
import { Logo } from "./Reveal";
import { scrollToId } from "./Navbar";

const COLS = [
  {
    title: "INTEGRA FRANCE",
    links: [
      { label: "Accueil", id: "accueil" },
      { label: "Comment ça marche", id: "comment" },
      { label: "Notre mission", id: "pourquoi" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    title: "ACCOMPAGNEMENT",
    links: [
      { label: "Coach civique", id: "coach" },
      { label: "Examen & Quiz", id: "examen" },
      { label: "Assistant démarches", id: "assistant" },
      { label: "Parcours d'intégration", id: "parcours" },
      { label: "Formations & ressources", id: "ressources" },
    ],
  },
  {
    title: "INFORMATIONS",
    links: [
      { label: "Mentions légales", href: "/conditions" },
      { label: "Devenir partenaire", href: "/devenir-partenaire" },
      { label: "Politique de confidentialité", href: "/confidentialite" },
      { label: "CGU", href: "/conditions" },
      { label: "Gestion des cookies", href: "#" },
      { label: "Accessibilité", href: "#" },
    ],
  },
  {
    title: "SOURCES OFFICIELLES",
    links: [
      { label: "Service-Public.fr", href: "https://www.service-public.fr" },
      { label: "Ministère de l'Intérieur", href: "https://www.interieur.gouv.fr" },
      { label: "OFII", href: "https://www.ofii.fr" },
      { label: "ANEF", href: "https://administration-etrangers-en-france.interieur.gouv.fr" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-bleu-night text-white" data-testid="footer">
      <div className="h-1 w-full bg-gradient-to-r from-bleu-accent via-white to-rouge" />
      <div className="container-integra py-16">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_2fr]">
          <div>
            <Link to="/"><Logo dark compact /></Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Votre parcours d'intégration, accompagné par l'IA.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-white/60">
              S'informer. Comprendre. Se préparer. Agir.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4">
            {COLS.map((col) => (
              <div key={col.title}>
                <h4 className="text-[11px] font-bold uppercase tracking-[0.16em] text-white/40">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.id ? (
                        <a
                          href={`#${l.id}`}
                          onClick={scrollToId(l.id)}
                          className="text-[13px] text-white/70 transition-colors hover:text-white"
                        >
                          {l.label}
                        </a>
                      ) : l.href?.startsWith("/") ? (
                        <Link to={l.href} className="text-[13px] text-white/70 transition-colors hover:text-white">
                          {l.label}
                        </Link>
                      ) : (
                        <a
                          href={l.href}
                          target={l.href?.startsWith("http") ? "_blank" : undefined}
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1 text-[13px] text-white/70 transition-colors hover:text-white"
                        >
                          {l.label}
                          {l.href?.startsWith("http") && <ExternalLink className="h-3 w-3 opacity-50" />}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex items-start gap-3 rounded-2xl border border-white/10 bg-white/5 px-5 py-4" data-testid="footer-disclaimer">
          <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" />
          <p className="text-xs leading-relaxed text-white/70">
            <strong className="text-white">INTEGRA FRANCE est un service indépendant</strong> et n'est pas un service
            officiel de l'administration française. Il ne remplace ni les administrations, ni les organismes officiels,
            ni les professionnels du droit ou de la formation.
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-7 text-xs text-white/50 sm:flex-row">
          <p>© 2026 INTEGRA FRANCE — Tous droits réservés</p>
          <p>Hébergé en Europe — Données protégées</p>
        </div>
      </div>
    </footer>
  );
}
